import React, { useState, useEffect } from "react";
import { useAdmin } from "../contexts/AdminContext";
import AdminLogin from "./AdminLogin";
import AdminDashboard from "./AdminDashboard";

const AdminAccess = () => {
  const { isAuthenticated } = useAdmin();
  const [showLogin, setShowLogin] = useState(false);
  const [showDashboard, setShowDashboard] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e) => {
      // Check if Cmd (Mac) or Ctrl (Windows/Linux) + Shift + A are all pressed
      const isModifierPressed = e.metaKey || e.ctrlKey; // metaKey for Mac, ctrlKey for Windows/Linux
      
      if (isModifierPressed && e.shiftKey && e.code === "KeyA") {
        e.preventDefault(); // Prevent default browser behavior
        setIsVisible(true);
        if (isAuthenticated) {
          setShowDashboard(true);
        } else {
          setShowLogin(true);
        }
      }
      
      // ESC key to close admin panels
      if (e.code === "Escape" && (showLogin || showDashboard)) {
        handleClose();
      }
    };

    // Add event listener to document
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isAuthenticated, showLogin, showDashboard]);

  const handleClose = () => {
    setShowLogin(false);
    setShowDashboard(false);
    setIsVisible(false);
  };

  // Don't render anything if not visible
  if (!isVisible) {
    return null;
  }

  return (
    <>
      {showLogin && !isAuthenticated && (
        <AdminLogin
          onClose={handleClose}
          onLoginSuccess={() => {
            setShowLogin(false);
            setShowDashboard(true);
          }}
        />
      )}

      {showDashboard && isAuthenticated && (
        <AdminDashboard onClose={handleClose} />
      )}
    </>
  );
};

export default AdminAccess;
